export default {
    loading: {
        module: false
    },
    params: {
        product_id: null,
        product_code: "",
        branch_office_id: Number(localStorage.selected_branchoffice),
        branch_office_warehouse_id: Number(localStorage.selected_branchoffice_warehouse),
        line_id: null,
        brand_id: null,
        optionQuery: 1,
        type_quey: 1,
    },
    branchOffices: [],
    branchoffice_warehouses: [],
    reportMinMax: [],
    lines: [],
    brands: [],
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-max-min/state.js